package br.com.vvrefeicoes.portal.core.util.file

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event
import org.w3c.files.FileReader
import kotlin.coroutines.resume

actual fun isPdfUploadSupported(): Boolean = true

actual suspend fun pickPdfFile(): PickedFile? =
    suspendCancellableCoroutine { continuation ->
        val input = document.createElement("input") as HTMLInputElement
        input.type = "file"
        input.accept = "application/pdf,.pdf"
        val onCancel: (Event) -> Unit = { if (continuation.isActive) continuation.resume(null) }
        input.addEventListener("cancel", onCancel)
        input.onchange = {
            val file = input.files?.item(0)
            if (file == null) {
                continuation.resume(null)
            } else {
                val reader = FileReader()
                reader.onload = {
                    // No Wasm o resultado é uma referência JS: `toString()` funciona em JS e em Wasm.
                    val binary = reader.result?.toString()
                    if (binary == null) {
                        continuation.resume(null)
                    } else {
                        val bytes = ByteArray(binary.length) { index -> binary[index].code.toByte() }
                        continuation.resume(PickedFile(file.name, bytes, file.type.ifBlank { "application/pdf" }))
                    }
                }
                reader.onerror = { continuation.resume(null) }
                reader.readAsBinaryString(file)
            }
        }
        input.click()
    }
